import { Badge, Button, ChoiceRadio, ChoiceRadioItem } from '@design-system';
import { ChevronLeft, Sparkles } from 'lucide-react';

import { useState } from 'react';

import type { FreemiumReflexiveOption } from '@shared';

interface ReflexiveQuestionProps {
  prompt: string;
  options: FreemiumReflexiveOption[];
  onSelect: (answerId: string) => void;
  onBack: () => void;
}

export function ReflexiveQuestion({ prompt, options, onSelect, onBack }: ReflexiveQuestionProps) {
  const [value, setValue] = useState<string | null>(null);

  return (
    <div className="mx-auto w-full max-w-xl">
      <div className="flex flex-col items-center gap-4 text-center">
        <Badge>
          <Sparkles />A quick question
        </Badge>
        <h1 className="text-balance text-3xl font-bold text-gray-950">{prompt}</h1>
      </div>

      <ChoiceRadio
        className="mt-6"
        value={value ?? undefined}
        onValueChange={setValue}
      >
        {options.map(option => (
          <ChoiceRadioItem
            key={option.id}
            value={option.id}
            title={option.label}
            description={option.description}
          />
        ))}
      </ChoiceRadio>

      <Button
        className="mt-6 w-full"
        size="lg"
        disabled={!value}
        onClick={() => value && onSelect(value)}
      >
        Continue
      </Button>

      <Button
        className="mt-3 w-full"
        size="lg"
        variant="outline"
        onClick={onBack}
      >
        <ChevronLeft />
        Back
      </Button>
    </div>
  );
}
